import { Auth, DataStore } from "aws-amplify";
import AWS from "aws-sdk";
import { Image } from "primereact/image";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { reactLocalStorage } from "reactjs-localstorage";
import googleLogin from "../../assets/images/google-icon.svg";
import loginLogo from "../../assets/images/login-logo.png";
import loginPage from "../../assets/images/login-page.svg";
import awsmobile from "../../aws-exports";
import ValidateEmail from "../../components/common/ValidateEmail";
import { USER_TYPES } from "../../helper/enum";
import { specialRoutes } from "../../helper/routeConstants";
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';
import { Employee, UserAppsPermission } from "../../models";
import { ProgressSpinner } from 'primereact/progressspinner';
import { API, graphqlOperation } from 'aws-amplify';
import * as queries from '../../graphql/queries';
import * as mutations from '../../graphql/mutations';
import { graphQLGetAllData } from '../../helper/commonfunctions';


export default function Login(props) {
  const location = useLocation();
  let navigateTo = useNavigate();
  console.log('location', location.pathname)

  const searchParams = new URLSearchParams(location.search);
  const [showPleaseWaitButton, setPleaseWaitButton] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isShowActivateGoogleAccountMessage, setShowActivateGoogleAccountMessage] = useState(false);
  const [isConfiguredInProgress, setIsConfiguredInProgress] = useState(false);
  let loggedUserId = '';

  //WAR_classified
  const { approvedReportId } = useParams();
  const { editReportId } = useParams();
  const { newReportId } = useParams();
  // End

  // WAR_certificated
  const { cerApprovedReportId } = useParams();
  const { cerEditReportId } = useParams();
  const { cerNewReportId } = useParams();
  
  //set Payroll email 
    const [payrollEmail, setPayrollEmail] = useState(process.env.REACT_APP_Payroll_Email);
	const [selectedL2Authority, setSelectedL2Authority] =useState("");
	

  //  Time Report

  const { tr_ReportId } = useParams();
  const { src_ReportId } = useParams();
  const { pa_ReportId } = useParams();

  const { sixPReportId } = useParams();

  const { srcReportIdPsa } = useParams();

  console.log("srcReportIdPsa999", srcReportIdPsa);



  // sub Request cert
  const { subCer_reportId } = useParams();

  const [typeOfUser, setTypeOfUser] = useState();

  useEffect(() => {
    const parts = location.pathname.split('/');
    const lastPart = parts[parts.length - 1];
    setTypeOfUser(lastPart)
    console.log('Last Part of Current Route Login:', lastPart);
    localStorage.setItem("lastPart", lastPart);
  }, [location.pathname]);

  const { type } = useParams();

  const NewlastPart = localStorage.getItem("lastPart");


  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
    secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
    region: process.env.REACT_APP_AWS_Region
  });

  async function checkLogin(e) {
    e.preventDefault()
    if (email === "") {
      toast.error("Enter email.");
      return;
    } else if (!ValidateEmail(email)) {
      toast.error("Invalid email.");
      return;
    } else if (password === "") {
      toast.error("Enter password.");
      return;
    }

    try {
      setPleaseWaitButton(true);
      const loggedUser = await Auth.signIn(email, password);

      if (loggedUser.challengeName === "NEW_PASSWORD_REQUIRED") {
        navigateTo("/createpassword", { state: { email: email, password: password } });
        navigateTo(0);
      } else {
        setAuthUserData(loggedUser);
        console.log('loggedUser== --->', loggedUser);
      }
    } catch (e) {
      setPleaseWaitButton(false);
      switch (e.message) {
        case "Username should be either an email or a phone number.":
          toast.error(e.message);
          break;
        case "Password did not conform with policy: Password not long enough":
          toast.error(e.message);
          break;
        case "User is not confirmed.":
          navigateTo("/confirmregistration", {
            state: {
              email: email,
              type: USER_TYPES.ADMIN
                ? USER_TYPES.ADMIN
                : USER_TYPES.INITIATOR
                  ? USER_TYPES.INITIATOR
                  : USER_TYPES.APPROVER
                    ? USER_TYPES.APPROVER
                    : USER_TYPES.PAYROLL
                      ? USER_TYPES.PAYROLL
                      : ""
            }
          });
          break;
        case "Incorrect username or password.":
          toast.error(e.message);
          break;
        case "User does not exist.":
          toast.error(e.message);
          break;
        default:
          toast.error(e.message);
      }
    }
  }
  
  
  //payroll user
   async function loadPayrollUsers() {

        try {
            const cognito = new AWS.CognitoIdentityServiceProvider();
            var params =
            {
                UserPoolId: awsmobile.aws_user_pools_id,
                Limit: 60,
                "Filter": "email ^= \"" + payrollEmail + "\"",
            };
			
console.log(payrollEmail,"payrollEmail")

            cognito.listUsers(params, (err, data) => {
                if (err) {
                    toast.error(err.message);
                } else {
                    var newRes = []
                    let userRole = '', userName = '', userEmail = '', userCode = '', sub = '';
                    (data.Users).forEach((user, i) => {
                        userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
                        userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
                        sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                        userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
                        //userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
                        let obj = {
                            "userId": sub,
                            "code": sub,
                            "name": userName,
                            "email": userEmail,
                            //"usercode": userCode,
                            "role": userRole ,
                        }
                        newRes.push(obj);
                    }
                    );
                    
                    const finalPayroll = newRes.length ? newRes[0] : newRes[0];
                    setSelectedL2Authority(finalPayroll)

                }
            });


        } catch (e) {
            toast.error(e.message);
        }
    }
	

  async function setAuthUserData(loggedUser) {


    // console.log('loggedUser: ',loggedUser)

    let loggedUserId = '';



    //Validate Google User in our system...
    //---------------------------------------------
    let loggedGoogleUsername = loggedUser.username;
    let IsUserLoggingWithGoogle = false;
    if (loggedUser) {
      IsUserLoggingWithGoogle = loggedGoogleUsername.startsWith("google_");
    }

    if (IsUserLoggingWithGoogle) {


      if (loggedUser.attributes["custom:role"] == null) {

        setIsConfiguredInProgress(true);

        //Pull Permission from table 1 - Role - Custom Role updates and Permission 
        let loggedGoogleEmail = loggedUser.attributes.email;

        //const returnPreSignupEmployee = await DataStore.query(PreSignupEmployee, (c) => c.email.eq(loggedGoogleEmail));
        let returnPreSignupEmployee = [];
        let nextToken = null;
        let hasMoreData = true;
        while (hasMoreData) {
          const result2 = await API.graphql(graphqlOperation(queries.listPreSignupEmployees, {
            filter: {
              email: { eq: loggedGoogleEmail }
            },
            limit: 1000,
            nextToken: nextToken,
          }));
          const { items, nextToken: newNextToken } = result2.data.listPreSignupEmployees;
          returnPreSignupEmployee = [...returnPreSignupEmployee, ...items];
          returnPreSignupEmployee = returnPreSignupEmployee.filter(item => item._deleted !== true);
          if (returnPreSignupEmployee.length > 0) {
            hasMoreData = false
          }
          else {
            hasMoreData = nextToken !== null && nextToken !== undefined ? nextToken : false;
          }
          nextToken = newNextToken;
        }


        if (returnPreSignupEmployee.length > 0) {

          let preSignupEmployee_role = returnPreSignupEmployee[0]['role'];
          let preSignupEmployee_reportingMangerEmail = returnPreSignupEmployee[0]['reportingMangerEmail'];
          let preSignupEmployee_employeeCode = returnPreSignupEmployee[0]['employeeCode'];
          let preSignupEmployee_employeeName = returnPreSignupEmployee[0]['employeeName'];
          let preSignupEmployee_schoolCode = returnPreSignupEmployee[0]['schoolCode'];
          let preSignupEmployee_userType = returnPreSignupEmployee[0]['userType'];
          let preSignupEmployee_isSixPeriodSAdmin = returnPreSignupEmployee[0]['isSixPeriodSAdmin'];
          let preSignupEmployee_sixPeriodIsInitiator = returnPreSignupEmployee[0]['sixPeriodIsInitiator'];
          let preSignupEmployee_sixPeriodIsApprover = returnPreSignupEmployee[0]['sixPeriodIsApprover'];
          let preSignupEmployee_sixPeriodIsPayroll = returnPreSignupEmployee[0]['sixPeriodIsPayroll'];
          let preSignupEmployee_certiSubRIsInitiator = returnPreSignupEmployee[0]['certiSubRIsInitiator'];
          let preSignupEmployee_certiSubReIsApprover = returnPreSignupEmployee[0]['certiSubReIsApprover'];
          let preSignupEmployee_certiSubReqIsPayroll = returnPreSignupEmployee[0]['certiSubReqIsPayroll'];
          let preSignupEmployee_designation = returnPreSignupEmployee[0]['designation'];
          let preSignupEmployee_timeRIsInitiator = returnPreSignupEmployee[0]['timeRIsInitiator'] ? returnPreSignupEmployee[0]['timeRIsInitiator'] : 0;
          let preSignupEmployee_timeRIsApprover = returnPreSignupEmployee[0]['timeRIsApprover'] ? returnPreSignupEmployee[0]['timeRIsApprover'] : 0;
          let preSignupEmployee_timeRIsPayroll = returnPreSignupEmployee[0]['timeRIsPayroll'] ? returnPreSignupEmployee[0]['timeRIsPayroll'] : 0;
          let preSignupEmployee_timeRIsSAdmin = returnPreSignupEmployee[0]['timeRIsSAdmin'] ? returnPreSignupEmployee[0]['timeRIsSAdmin'] : 0;

          let preSignupEmployee_employeeFirstName = '';
          let preSignupEmployee_employeeLastName = '';
          let myEmployeeNameArray = preSignupEmployee_employeeName.trim().split(" ");
          preSignupEmployee_employeeFirstName = myEmployeeNameArray[0];
          if (myEmployeeNameArray.length > 1) {
            if (myEmployeeNameArray[1] != null) {
              preSignupEmployee_employeeLastName = myEmployeeNameArray[1];
            }
          }




          //Get Reporting Manager Id
          //const reportingManagerEmployee = await DataStore.query(Employee, (c) => c.email.eq(preSignupEmployee_reportingMangerEmail));
          let reportingManagerEmployee = [];
          nextToken = null;
          hasMoreData = true;
          while (hasMoreData) {
            const result2 = await API.graphql(graphqlOperation(queries.listEmployees, {
              filter: {
                email: { eq: preSignupEmployee_reportingMangerEmail }
              },
              limit: 1000,
              nextToken: nextToken,
            }));
            const { items, nextToken: newNextToken } = result2.data.listEmployees;
            reportingManagerEmployee = [...reportingManagerEmployee, ...items];
            reportingManagerEmployee = reportingManagerEmployee.filter(item => item._deleted !== true);
            if (reportingManagerEmployee.length > 0) {
              hasMoreData = false
            }
            else {
              hasMoreData = nextToken !== null && nextToken !== undefined ? nextToken : false;
            }
            nextToken = newNextToken;
          }

          let reportingManagerEmployeeId = '';
          if (reportingManagerEmployee.length > 0) {
            reportingManagerEmployeeId = reportingManagerEmployee[0].id
          }

          console.log('reportingManagerEmployeeId: ', reportingManagerEmployeeId)

          //Push code to user permission table table...
          const cognito = new AWS.CognitoIdentityServiceProvider();
          const params = {
            UserPoolId: awsmobile.aws_user_pools_id,
            Username: loggedGoogleUsername,
            UserAttributes: [
              {
                Name: "name",
                Value: preSignupEmployee_employeeName,
              },
              {
                Name: "custom:firstName",
                Value: preSignupEmployee_employeeFirstName,
              },
              {
                Name: "custom:lastName",
                Value: preSignupEmployee_employeeLastName,
              },
              {
                Name: "custom:role",
                Value: (preSignupEmployee_role) ? preSignupEmployee_role : '',
              },
              {
                Name: "custom:schoolId",
                Value: preSignupEmployee_schoolCode,
              },
              {
                Name: "custom:SPReportingManager",
                Value: reportingManagerEmployeeId
              },
              {
                Name: "custom:reportingManagerId",
                Value: reportingManagerEmployeeId
              },
              {
                Name: "custom:userCode",
                Value: (preSignupEmployee_employeeCode) ? preSignupEmployee_employeeCode : '-',
              },
              {
                Name: "custom:userType",
                Value: (preSignupEmployee_userType) ? preSignupEmployee_userType : '-',
              },


              //six period access
              {
                Name: "custom:sixPeriodIsInitiator",
                Value: preSignupEmployee_sixPeriodIsInitiator,
              },
              {
                Name: "custom:sixPeriodIsApprover",
                Value: preSignupEmployee_sixPeriodIsApprover,
              },
              {
                Name: "custom:sixPeriodIsPayroll",
                Value: preSignupEmployee_sixPeriodIsPayroll,
              },
              {
                Name: "custom:isSixPeriodSAdmin",
                Value: preSignupEmployee_isSixPeriodSAdmin,
              },

              //Certificate Sub Action access
              {
                Name: "custom:certiSubRIsInitiator",
                Value: preSignupEmployee_certiSubRIsInitiator
              },
              {
                Name: "custom:certiSubReIsApprover",
                Value: preSignupEmployee_certiSubReIsApprover,
              },
              {
                Name: "custom:certiSubReqIsPayroll",
                Value: preSignupEmployee_certiSubReqIsPayroll,
              },


              //Time Report Action access
              {
                Name: "custom:timeRIsInitiator",
                Value: preSignupEmployee_timeRIsInitiator
              },
              {
                Name: "custom:timeRIsApprover",
                Value: preSignupEmployee_timeRIsApprover,
              },
              {
                Name: "custom:timeRIsPayroll",
                Value: preSignupEmployee_timeRIsPayroll,
              },
              {
                Name: "custom:timeRIsSAdmin",
                Value: preSignupEmployee_timeRIsSAdmin,
              },


            ],
          };

          //Once update attributes
          try {
            cognito.adminUpdateUserAttributes(params, async function (err, data) {

              if (err) {
                console.log("Errr rr", err, err.stack);
              }
              else {
                console.log('User attribute updated successfully.');
              }

            });

          } catch (error) {
            console.error('Error updating user attribute:', error);
          }


          //App Assign
          //const returnPreSignupEmployeeApps = await DataStore.query(PreSignupEmployeeApps, (c) => c.email.eq(loggedGoogleEmail));
          let returnPreSignupEmployeeApps = [];
          nextToken = null;
          hasMoreData = true;
          while (hasMoreData) {
            const result2 = await API.graphql(graphqlOperation(queries.listPreSignupEmployeeApps, {
              filter: {
                email: { eq: loggedGoogleEmail }
              },
              limit: 1000,
              nextToken: nextToken,
            }));
            const { items, nextToken: newNextToken } = result2.data.listPreSignupEmployeeApps;
            returnPreSignupEmployeeApps = [...returnPreSignupEmployeeApps, ...items];
            returnPreSignupEmployeeApps = returnPreSignupEmployeeApps.filter(item => item._deleted !== true);
            if (returnPreSignupEmployeeApps.length > 0) {
              hasMoreData = false
            }
            else {
              hasMoreData = nextToken !== null && nextToken !== undefined ? nextToken : false;
            }
            nextToken = newNextToken;
          }
          console.log('returnPreSignupEmployeeApps: ', returnPreSignupEmployeeApps)
          console.log('loggedGoogleUsername: ', loggedUser.attributes["sub"])


          //Delete Permission
          await DataStore.delete(UserAppsPermission, (c) => c.UserId.eq(loggedUser.attributes["sub"]));

          //Save Mutatioon
          // returnPreSignupEmployeeApps.map(async (item) => {
          //   console.log('AppId: ',item.appId)
          //   await DataStore.save(
          //     new UserAppsPermission({
          //       "UserId": loggedUser.attributes["sub"],
          //       "AppId": item.appId
          //     })
          //   )
          // })

          returnPreSignupEmployeeApps.map(async (item) => {
            await API.graphql(
              graphqlOperation(mutations.createUserAppsPermission, {
                input: {
                  UserId: loggedUser.attributes["sub"],
                  AppId: item.appId
                }
              })
            );
          })



          //Create Employee
          //const existingEmployee = await DataStore.query(Employee, (c) => c.email.eq(loggedGoogleEmail));
          let existingEmployee = [];
          nextToken = null;
          hasMoreData = true;
          while (hasMoreData) {
            const result2 = await API.graphql(graphqlOperation(queries.listEmployees, {
              filter: {
                user_Id: { eq: loggedUser.attributes["sub"] }
              },
              limit: 1000,
              nextToken: nextToken,
            }));
            const { items, nextToken: newNextToken } = result2.data.listEmployees;
            existingEmployee = [...existingEmployee, ...items];
            existingEmployee = existingEmployee.filter(item => item._deleted !== true);
            if (existingEmployee.length > 0) {
              hasMoreData = false
            }
            else {
              hasMoreData = nextToken !== null && nextToken !== undefined ? nextToken : false;
            }
            nextToken = newNextToken;
          }


          if (existingEmployee.length > 0) {
            let existingEmployeeId = existingEmployee[0].id;
            let existingEmployeeVersion = existingEmployee[0]._version;
            console.log('existingEmployeeId: ', existingEmployeeId)
            console.log('version: ', existingEmployeeId)

            // let originalEmployee = await DataStore.query(Employee, existingEmployeeId);
            // console.log('originalEmployee: ',originalEmployee)
            // let savedEmployee = await DataStore.save(
            //   Employee.copyOf(originalEmployee, (updated) => {
            //     updated.user_Id = loggedUser.attributes["sub"];
            //   })
            // );
            // console.log('updateEmployee: ',savedEmployee)

            //Commented on 29 Aug - Due to notificaiton issues
            // await API.graphql({
            //   query: mutations.updateEmployee,
            //   variables: {
            //       input: {
            //           id: existingEmployeeId,
            //           _version: existingEmployeeVersion,
            //           user_Id: loggedUser.attributes["sub"]
            //       }
            //   }
            // });

            console.log('updated Employee')

          }
          else {

            // let savedEmployee = await DataStore.save(
            //   new Employee({
            //     "employee_name": preSignupEmployee_employeeName,
            //     "phone_no": '',
            //     "email": loggedGoogleEmail,
            //     "address_1": '',
            //     "address_2": '',
            //     "city": '',
            //     "zip_code": '',
            //     "state": '',
            //     "country": '',
            //     "employee_code": preSignupEmployee_employeeCode,
            //     "school_id": preSignupEmployee_schoolCode,
            //     "employeeType": preSignupEmployee_userType,
            //     "user_Id": loggedUser.attributes["sub"],
            //     "designation": preSignupEmployee_designation,
            //   })
            // );


            await API.graphql(
              graphqlOperation(mutations.createEmployee, {
                input: {
                  employee_name: preSignupEmployee_employeeName,
                  phone_no: '',
                  email: loggedGoogleEmail,
                  address_1: '',
                  address_2: '',
                  city: '',
                  zip_code: '',
                  state: '',
                  country: '',
                  employee_code: preSignupEmployee_employeeCode,
                  school_id: preSignupEmployee_schoolCode,
                  employeeType: preSignupEmployee_userType,
                  user_Id: loggedUser.attributes["sub"],
                  designation: preSignupEmployee_designation,
                  role: preSignupEmployee_role,
                }
              })
            );

            console.log('Saved Employee')

          }


        }
        else {
          setIsConfiguredInProgress(false);
          setShowActivateGoogleAccountMessage(true);
          reactLocalStorage.clear();
          toast.dismiss();
          toast.error("You don't have permission to use this application. Please first activate your role from admin panel.", { autoClose: 15000 });
          return;
        }
        setIsConfiguredInProgress(false);
        setShowActivateGoogleAccountMessage(true);
        reactLocalStorage.clear();
        toast.dismiss();
        toast.error("Your access request for the application is being configured. Please sign out and sign in after 2 minutes.", { autoClose: 15000 });
        return;

      }

      setIsConfiguredInProgress(false);
      loggedUserId = loggedUser.attributes["sub"];

    }
    else {
      loggedUserId = loggedUser.attributes["sub"];
    }
    //---------------------------------------------

    setIsConfiguredInProgress(false);
    console.log('loggedUserId', loggedUserId)
    console.log('loggedUser.attributes', loggedUser.attributes)


    // Check USER TYPE
    if (loggedUser) {
      
      setPleaseWaitButton(false);
      let listUserAdditionalSettingsData = [];

      let nextToken4 = null;
      let hasMoreData = true;
      while (hasMoreData) {
        const result2 = await API.graphql(graphqlOperation(queries.listUserAdditionalSettings, { filter: { userId: { eq: loggedUser.attributes["sub"] } }, limit: 1000, nextToken: nextToken4 }));

        console.log("listUserAdditionalSettingsData", result2);

        const { items, nextToken: newNextToken } = result2.data.listUserAdditionalSettings;

        listUserAdditionalSettingsData = [...listUserAdditionalSettingsData, ...items];
        nextToken4 = newNextToken;
        hasMoreData = nextToken4 !== null && nextToken4 !== undefined ? nextToken4 : false;
      }
      listUserAdditionalSettingsData = listUserAdditionalSettingsData.filter(item => item._deleted !== true);
      console.log("listUserAdditionalSettingsData listUserAdditionalSettingsData", listUserAdditionalSettingsData);

      //Stipend
      let stipendApprover = listUserAdditionalSettingsData.length > 0 && listUserAdditionalSettingsData[0]['stipendApprover'] ? listUserAdditionalSettingsData[0]['stipendApprover'] : '0';
      let stipendInitiator = listUserAdditionalSettingsData.length > 0 && listUserAdditionalSettingsData[0]['stipendInitiator'] ? listUserAdditionalSettingsData[0]['stipendInitiator'] : '0';
      let stipendPayroll = listUserAdditionalSettingsData.length > 0 && listUserAdditionalSettingsData[0]['stipendPayroll'] ? listUserAdditionalSettingsData[0]['stipendPayroll'] : '0';

      //personnelServiceAgree
      let personnelServiceAgreeInitiator = listUserAdditionalSettingsData.length > 0 && listUserAdditionalSettingsData[0]['personnelServiceAgreeInitiator'] ? listUserAdditionalSettingsData[0]['personnelServiceAgreeInitiator'] : '0';
      let personnelServiceAgreeApprover = listUserAdditionalSettingsData.length > 0 && listUserAdditionalSettingsData[0]['personnelServiceAgreeApprover'] ? listUserAdditionalSettingsData[0]['personnelServiceAgreeApprover'] : '0';

      //Substitute Request Classified field 
      let subClassifiedSuperAdmin = listUserAdditionalSettingsData.length > 0 && listUserAdditionalSettingsData[0]?.['subReqClassifiedSuperAdmin'] ? listUserAdditionalSettingsData[0]['subReqClassifiedSuperAdmin'] : '0';


      reactLocalStorage.set("subClassifiedSuperAdmin", subClassifiedSuperAdmin);
      let isWARClassifSAdmin = listUserAdditionalSettingsData.length > 0 && listUserAdditionalSettingsData[0]?.['isWARClassifiedSuperAdmin'] ? listUserAdditionalSettingsData[0]['isWARClassifiedSuperAdmin'] : '0';

      reactLocalStorage.set("WARClassifIsSuperadmin", isWARClassifSAdmin);
      let isWARCertificatedSAdmin = listUserAdditionalSettingsData.length > 0 && listUserAdditionalSettingsData[0]?.['isWARCertificatedSuperAdmin'] ? listUserAdditionalSettingsData[0]['isWARCertificatedSuperAdmin'] : '0';

      let isSixthPeriodSuperAdmin = listUserAdditionalSettingsData.length > 0 && listUserAdditionalSettingsData[0]?.['isSixthPeriodSuperAdmin'] ? listUserAdditionalSettingsData[0]['isSixthPeriodSuperAdmin'] : '0';

      let isStipendSuperAdmin = listUserAdditionalSettingsData.length > 0 && listUserAdditionalSettingsData[0]?.['isStipendSuperAdmin'] ? listUserAdditionalSettingsData[0]['isStipendSuperAdmin'] : '0';

      let isPersonalServiceSuperAdmin = listUserAdditionalSettingsData.length > 0 && listUserAdditionalSettingsData[0]?.['isPersonalServiceSuperAdmin'] ? listUserAdditionalSettingsData[0]['isPersonalServiceSuperAdmin'] : '0';


      reactLocalStorage.set("isSixthPeriodSuperAdmin", isSixthPeriodSuperAdmin);
      reactLocalStorage.set("isPersonalServiceSuperAdmin", isPersonalServiceSuperAdmin);
      reactLocalStorage.set("isStipendSuperAdmin", isStipendSuperAdmin);
      reactLocalStorage.set("isWARCertificatedSuperAdmin", isWARCertificatedSAdmin);
      reactLocalStorage.set("loggedStipendApprover", stipendApprover);
      reactLocalStorage.set("loggedStipendInitiator", stipendInitiator);
      reactLocalStorage.set("loggedStipendPayroll", stipendPayroll);
      reactLocalStorage.set("loggedPersonnelServiceAgreeInitiator", personnelServiceAgreeInitiator);
      reactLocalStorage.set("loggedPersonnelServiceAgreeApprover", personnelServiceAgreeApprover);
      reactLocalStorage.set("loggedUserRole", loggedUser.attributes["custom:role"]);
      reactLocalStorage.set("loggedUserId", loggedUserId);
      reactLocalStorage.set("loggedFirstName", loggedUser.attributes["custom:firstName"]);
      reactLocalStorage.set("loggedLastName", loggedUser.attributes["custom:lastName"]);
      reactLocalStorage.set("loggedl1authority", loggedUser.attributes["custom:L1_authoritys"]);
      
	  //reactLocalStorage.set("loggedl2authority", loggedUser.attributes["custom:L2_authoritys"]);
	  //l2 for all users
	  if(selectedL2Authority){
		reactLocalStorage.set("loggedl2authority", selectedL2Authority?.code);
	  }

      //set reporting manager in 
      if (loggedUser.attributes["custom:SPReportingManager"]) {
        reactLocalStorage.set("SPReportingManager", loggedUser.attributes["custom:SPReportingManager"]);
      }

      //set Weekly absence report certificated admin form access

      if (loggedUser.attributes["custom:isWARCertSAdmin"]) {
        reactLocalStorage.set("isWARCertSAdmin", loggedUser.attributes["custom:isWARCertSAdmin"]);
      }
      //set six-period form access
      if (loggedUser.attributes["custom:sixPeriodIsInitiator"]) {
        reactLocalStorage.set("sixPeriodIsInitiator", loggedUser.attributes["custom:sixPeriodIsInitiator"]);
      }
      if (loggedUser.attributes["custom:sixPeriodIsApprover"]) {
        reactLocalStorage.set("sixPeriodIsApprover", loggedUser.attributes["custom:sixPeriodIsApprover"]);
      }
      if (loggedUser.attributes["custom:sixPeriodIsPayroll"]) {
        reactLocalStorage.set("sixPeriodIsPayroll", loggedUser.attributes["custom:sixPeriodIsPayroll"]);
      }
      if (loggedUser.attributes["custom:isSixPeriodSAdmin"]) {
        reactLocalStorage.set("sixPeriodIsSuperadmin", loggedUser.attributes["custom:isSixPeriodSAdmin"]);
      }


      //set Personnel -action form access
      if (loggedUser.attributes["custom:personnelIsInitiator"]) {
        reactLocalStorage.set("personnelIsInitiator", loggedUser.attributes["custom:personnelIsInitiator"]);
      }
      if (loggedUser.attributes["custom:personnelIsApprover"]) {
        reactLocalStorage.set("personnelIsApprover", loggedUser.attributes["custom:personnelIsApprover"]);
      }
      if (loggedUser.attributes["custom:personnelIsPayroll"]) {
        reactLocalStorage.set("personnelIsPayroll", loggedUser.attributes["custom:personnelIsPayroll"]);
      }
      if (loggedUser.attributes["custom:ispersonnelIsAdmin"]) {
        reactLocalStorage.set("personnelActionIsSuperadmin", loggedUser.attributes["custom:ispersonnelIsAdmin"]);
      }




      //set time-report form access
      if (loggedUser.attributes["custom:timeRIsInitiator"]) {
        reactLocalStorage.set("timeReportIsInitiator", loggedUser.attributes["custom:timeRIsInitiator"]);
      }
      if (loggedUser.attributes["custom:timeRIsApprover"]) {
        reactLocalStorage.set("timeReportIsApprover", loggedUser.attributes["custom:timeRIsApprover"]);
      }
      if (loggedUser.attributes["custom:timeRIsPayroll"]) {
        reactLocalStorage.set("timeReportIsPayroll", loggedUser.attributes["custom:timeRIsPayroll"]);
      }
      if (loggedUser.attributes["custom:timeRIsSAdmin"]) {
        reactLocalStorage.set("timeRIsSAdmin", loggedUser.attributes["custom:timeRIsSAdmin"]);
      }

      if (loggedUser.attributes["custom:empId"]) {
        reactLocalStorage.set("empID", loggedUser.attributes["custom:empId"]);
      }
      //set certificated substitute report form access code start.
      if (loggedUser.attributes["custom:certiSubRIsInitiator"]) {
        reactLocalStorage.set("certificatedSubReqIsInitiator", loggedUser.attributes["custom:certiSubRIsInitiator"]);
      }
      if (loggedUser.attributes["custom:certiSubReIsApprover"]) {
        reactLocalStorage.set("certificatedSubReqIsApprover", loggedUser.attributes["custom:certiSubReIsApprover"]);
      }
      if (loggedUser.attributes["custom:certiSubReqIsPayroll"]) {
        reactLocalStorage.set("certificatedSubReqIsPayroll", loggedUser.attributes["custom:certiSubReqIsPayroll"]);
      }
      if (loggedUser.attributes["custom:isSubCertSAdmin"]) {
        reactLocalStorage.set("isSubCertSAdmin", loggedUser.attributes["custom:isSubCertSAdmin"]);
      }
      //set certificated substitute report form access code end.

      // reactLocalStorage.set("loggedAdminProfilePic", "https://lh3.googleusercontent.com/-XdUIqdMkCWA/AAAAAAAAAAI/AAAAAAAAAAA/4252rscbv5M/photo.jpg");
      // if (GetValueFromArray(loggedUser.Attributes, "custom:profileImage") != null) {
      //   await Storage.get(GetValueFromArray(loggedUser.Attributes, "custom:profileImage")).then(result => {
      //     reactLocalStorage.set("loggedAdminProfilePic", result);
      //   });
      // }

      if (searchParams.get(specialRoutes.sixth_period_report_approval_request)) {
        // 11fd1688-923d-4b91-9a25-6ea4f1e6f4c3
        const path =
          "/sixth_period_report_list?" +
          specialRoutes.sixth_period_report_approval_request +
          "=" +
          searchParams.get(specialRoutes.sixth_period_report_approval_request);
        navigateTo(path);
        return;
      }
      if (searchParams.get(specialRoutes.handbook)) {
        navigateTo("/employee-agreement-handbook");
        return;
      }

      if (loggedUser.attributes["custom:role"] === USER_TYPES.ADMIN) {
        navigateTo("/dashboard");
        //navigateTo(0);
      }
      else if (loggedUser.attributes["custom:role"] === 'I') {
        if (location.pathname != '/') {
          if (approvedReportId) {
            const path =
              `/initiator/weekly_absence_report/${approvedReportId}`;
            if (path === location.pathname) {
              navigateTo(path);
              navigateTo(0);
            }
            else {
              reactLocalStorage.clear();
              navigateTo("/")
            }
          }
          else if (cerApprovedReportId) {
            const path =
              `/initiator/weekly_absent_report_certificated_admin/${cerApprovedReportId}`;

            if (path === location.pathname) {
              navigateTo(path);
              navigateTo(0);
            }
            else {
              reactLocalStorage.clear();
              navigateTo("/")
            }
          }
          
          else if (tr_ReportId) {
            console.log('location', location.search)
            const path =
              `/time_report/${tr_ReportId}`;
            if (typeOfUser === "initiator") {
              navigateTo(path);
              navigateTo(0);
            }
            else {
              reactLocalStorage.clear();
              navigateTo("/")
            }
          }
          else if (src_ReportId) {
            console.log('location', location.search)
            const path =
              `/classified_substitute_request/${src_ReportId}/initiator`;
            if (typeOfUser === "initiator") {
              navigateTo(path);
              navigateTo(0);
            }

            else {
              reactLocalStorage.clear();
              navigateTo("/")
            }
          }
          else if (subCer_reportId) {
            const path =
              `/substitute_request_certificated/${subCer_reportId}/${type}`;
            if (typeOfUser === "initiator") {
              navigateTo(path);
              navigateTo(0);
            }
            else {
              reactLocalStorage.clear();
              navigateTo("/")
            }
          }
          else if (pa_ReportId) {
            const parts = location.pathname.split('/');
            const isReject = parts[parts.length - 2];

            const path =
            isReject == "reject" ?
             `${specialRoutes.personal_action_report_approval_request2}/${pa_ReportId}/reject/initiator` :
             `${specialRoutes.personal_action_report_approval_request2}/${pa_ReportId}/initiator`


            if (typeOfUser === "initiator") {
              navigateTo(path);
              navigateTo(0);
            }
            else {
              reactLocalStorage.clear();
              navigateTo("/")
            }
           

           
          }
          else if (sixPReportId) {
            const path =
              `${specialRoutes.sixth_period_report_approval_request2}/${sixPReportId}/initiator`;
            if (typeOfUser === "initiator") {
              navigateTo(path);
              navigateTo(0);
            }
            else {
              reactLocalStorage.clear();
              navigateTo("/")
            }
          }
          
          if (srcReportIdPsa) {
            let path;
            if (typeOfUser === "initiator") {
              path = `${specialRoutes.personalServiceAgreement}/${srcReportIdPsa}/initiator`;
            } else if (typeOfUser === "approver") {
              path = `${specialRoutes.personalServiceAgreement}/${srcReportIdPsa}/approver`;
            } else if (typeOfUser === "reject") {
              path = `${specialRoutes.personalServiceAgreement}/${srcReportIdPsa}/reject`;
            } else {
              reactLocalStorage.clear();
              // navigateTo("/")
              return; // If you want to exit the function or block here
            }
          
            navigateTo(path);
            navigateTo(0);
          }
          
          else {
            reactLocalStorage.clear();
            // navigateTo("/")
          }
        }
        else {
          navigateTo("/all-app-dashboard");
        }
      }
      else if (loggedUser.attributes["custom:role"] === 'AP') {
        if (location.pathname != '/') {
          if (editReportId) {
            const path =
              `/approver/weekly_absence_report/${editReportId}`;
            if (path === location.pathname) {
              navigateTo(path);
              navigateTo(0);
            } else {
              reactLocalStorage.clear();
              navigateTo("/")
            }
          }

          else if (cerEditReportId) {
            const path =
              `/approver/weekly_absent_report_certificated_admin/${cerEditReportId}`;
            if (path === location.pathname) {
              navigateTo(path);
              navigateTo(0);
            }
            else {
              reactLocalStorage.clear(); // Clear or expire the session here
              console.log("Session cleared.");
              navigateTo("/");
            }
          }
          else if (tr_ReportId) {
            const path =
              `/time_report/${tr_ReportId}`;
            if (typeOfUser === "approver") {
              navigateTo(path);
              navigateTo(0);
            }
            else {
              reactLocalStorage.clear();
              navigateTo("/")
            }
          }
          else if (src_ReportId) {
            const path =
              `/classified_substitute_request/${src_ReportId}/approver`;
            if (typeOfUser === "approver") {
              navigateTo(path);
              navigateTo(0);
            }
            else {
              reactLocalStorage.clear();
              navigateTo("/")
            }
          }
          else if (pa_ReportId) {
            const path =
              `${specialRoutes.personal_action_report_approval_request2}/${pa_ReportId}/approver`;
            if (typeOfUser === "approver") {
              navigateTo(path);
              navigateTo(0);
            }
            else {
              reactLocalStorage.clear();
              navigateTo("/")
            }
          }
          else if (sixPReportId) {
            const path =
              `${specialRoutes.sixth_period_report_approval_request2}/${sixPReportId}/approver`;
            if (typeOfUser === "approver") {
              navigateTo(path);
              navigateTo(0);
            }
            else {
              reactLocalStorage.clear();
              navigateTo("/")
            }
          }
          if (srcReportIdPsa) {
            let path;
            if (typeOfUser === "initiator") {
              path = `${specialRoutes.personalServiceAgreement}/${srcReportIdPsa}/initiator`;
            } else if (typeOfUser === "approver") {
              path = `${specialRoutes.personalServiceAgreement}/${srcReportIdPsa}/approver`;
            } else if (typeOfUser === "reject") {
              path = `${specialRoutes.personalServiceAgreement}/${srcReportIdPsa}/reject`;
            } else {
              reactLocalStorage.clear();
              // navigateTo("/")
              return; // If you want to exit the function or block here
            }
            navigateTo(path);
            navigateTo(0);
          }
          
          else if (subCer_reportId) {
            const path =
              `/substitute_request_certificated/${subCer_reportId}/${type}`;
            if (typeOfUser === "approver") {
              navigateTo(path);
              navigateTo(0);
            }
            else {
              reactLocalStorage.clear();
              navigateTo("/")
            }
          }
          else {
            reactLocalStorage.clear();
            // navigateTo("/")
          }
        }


        else {
          navigateTo("/all-app-dashboard");
        }

      }
      else if (loggedUser.attributes["custom:role"] === 'P') {
        if (location.pathname != '/') {
          if (newReportId) {
            const path =
              `/payroll/weekly_absence_report/${newReportId}`;
            if (path === location.pathname) {
              navigateTo(path);
              navigateTo(0);
            } else {
              reactLocalStorage.clear();
              navigateTo("/")
            }
          }
          else if (srcReportIdPsa) {
            const path =
              `/personalserviceagreement/${srcReportIdPsa}/reject`;
            if (typeOfUser === "reject") {
              navigateTo(path);
              navigateTo(0);
            }
            else {
              reactLocalStorage.clear();
              navigateTo("/")
            }

          }
          else if (cerNewReportId) {
            const path =
              `/payroll/weekly_absent_report_certificated_admin/${cerNewReportId}`;
            if (path === location.pathname) {
              navigateTo(path);
              navigateTo(0);
            }
            else {
              reactLocalStorage.clear();
              navigateTo("/")
            }
          }
          else if (tr_ReportId) {
            const path =
              `/time_report/${tr_ReportId}`;
            if (typeOfUser === "payroll") {
              navigateTo(path);
              navigateTo(0);
            }
            else {
              reactLocalStorage.clear();
              navigateTo("/")
            }
          }
          else if (src_ReportId) {
            const path =
              `/classified_substitute_request/${src_ReportId}/payroll`;
            if (typeOfUser === "payroll") {
              navigateTo(path);
              navigateTo(0);
            }
            else {
              reactLocalStorage.clear();
              navigateTo("/")
            }
          }
          else if (pa_ReportId) {
            const path =
              `${specialRoutes.personal_action_report_approval_request2}/${pa_ReportId}/payroll`;
            if (typeOfUser === "payroll") {
              navigateTo(path);
              navigateTo(0);
            }
            else {
              reactLocalStorage.clear();
              navigateTo("/")
            }
          }
          else if (sixPReportId) {
            const path =
              `${specialRoutes.sixth_period_report_approval_request2}/${sixPReportId}/payroll`;
            if (typeOfUser === "payroll") {
              navigateTo(path);
              navigateTo(0);
            }
            else {
              reactLocalStorage.clear();
              navigateTo("/")
            }
          }
          
          else if (srcReportIdPsa) {

            const path =
              `/personalserviceagreement/${srcReportIdPsa}/payroll`;
            if (typeOfUser === "payroll") {
              navigateTo(path);
              navigateTo(0);
            }
            else {
              reactLocalStorage.clear();
              navigateTo("/")
            }

          }
          else if (subCer_reportId) {
            const path =
              `/substitute_request_certificated/${subCer_reportId}/${type}`;
            if (typeOfUser === "payroll") {
              navigateTo(path);
              navigateTo(0);
            }
            else {
              reactLocalStorage.clear();
              navigateTo("/")
            }
          }
          else {
            reactLocalStorage.clear();
            // navigateTo("/")
          }
        } else {
          navigateTo("/all-app-dashboard");
        }
      }


      else {
        navigateTo("/all-app-dashboard");
        //navigateTo(0);
      }
    } else {
      setPleaseWaitButton(false);
    }
  }

  async function onLoad() {
    await Auth.currentSession();
  }
  
  async function onLoadPayroll() {
    await  loadPayrollUsers();
  }

  useEffect(() => {
    onLoad();
	
    setPleaseWaitButton(false);
    Auth.currentAuthenticatedUser()
      .then(currentUser => setAuthUserData(currentUser))
      .catch(() => console.log("Not signed in"));
	  
	onLoadPayroll() 

  }, []);


  useEffect(() => {
    const parts = location.pathname.split('/');
    const lastPart = parts[parts.length - 1];
    setTypeOfUser(lastPart)
    console.log('Last Part of Current Route TR:', lastPart);

  }, [location.pathname])


  const signOutWithGoogle = async () => {
    reactLocalStorage.clear();
    await Auth.signOut();
    let redirectURL = 'https://' + awsmobile.oauth.domain + '/logout?client_id=' + awsmobile.aws_user_pools_web_client_id + '&logout_uri=' + window.location.href;
    window.location.href = redirectURL;
  };

  /* const signInWithGoogle = async () => {
    console.log('Start with Google')
    try {
      const user = await Auth.currentAuthenticatedUser();
      console.log('Current Google User')
      console.log(user);
      if (user) {
        setAuthUserData(user);
      }
    } catch (e) {
      console.log('Expection: ' + e)
      await Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Google })
        .then(e => setAuthUserData(e))
        .catch(err => console.log('Error: ' + err));
    }
  }; */

  return (
    <>
      {/* <Head> */}
      <title>GUSD forms</title>
      <meta name="description" content="" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="icon" to="/favicon.ico" />
      {/* </Head> */}

      <div className="overflow-auto login">
        <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2">
          <div className="flex flex-wrap flex-row justify-center login bg-transparent dark:bg-[#1E2124] xl:border-r xl:border[#F9FAFB] xl:border-opacity-10">
            <div className="w-full p-2 px-10 2xl:max-w-lg xl:max-w-lg" data-aos="fade-right" data-aos-duration="800">
              <div className="flex flex-wrap items-center mt-8 mb-3">
                <Image
                  className="relative xl:h-[5.469vw] xl:w-[5.469vw]"
                  src={loginLogo}
                  width={"103"}
                  height={"105"}
                  alt="GUSD App"
                />
              </div>

              {props.sessionExpired === 1 ? (
                <div className="relative px-4 py-3 mb-5 text-red-700 bg-red-100 border border-red-400 rounded">
                  <span className="text-sm text-red-600">Session expired. Please login again.</span>
                </div>
              ) : (
                ""
              )}

              <div className="mb-2 xl:mb-[2.083vw]">
                <h2 className="text-[24px] xl:text-[1.875vw] font-semibold text-[#101828] dark:text-white">
                  Welcome to <span className="text-[#05A6F6]">GUSD</span> forms
                </h2>
              </div>
              {isShowActivateGoogleAccountMessage ?
                (

                  <button
                    onClick={() => signOutWithGoogle()}
                    className="text-[14px] text-[#FFF] bg-red-500 mb-8 xl:mb-[2.083vw] flex items-center justify-center font-medium  googlebtn p-3"
                  >
                    <Image className="mr-2" src={googleLogin} width={"20"} height={"20"} alt="Sign out with Google" /> Sign out from Google
                  </button>

                ) :
                (

                  <>

                    <div className="text-[#344054] text-sm lg:text-lg xl:text-[0.938vw] font-medium py-2">
                      Please enter details to Login
                    </div>

                    {/*  <button
                      onClick={() => signInWithGoogle()} disabled
                      className="text-[14px] text-[#101828] bg-white mb-8 xl:mb-[2.083vw] flex items-center justify-center font-medium  googlebtn p-3"
                    >
                      <Image className="mr-2" src={googleLogin} width={"20"} height={"20"} alt="Sign in with Google" /> 
                      {showPleaseWaitButton ? "Please wait..." : "Sign in with Google"}

                    </button> */}
                    {isConfiguredInProgress ? <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" /> : ""}

                    <div className="my-2 xl:my-[0.521vw] sign">
                      <div className="text-[#98A2B3] text-sm font-normal">Sign in with Email</div>
                    </div>

                    <form onSubmit={(e) => checkLogin(e)}>
                      <div className="relative  mb-2 xl:mb-[0.781vw]">
                        <div className="py-2">
                          <label htmlFor="required-email" className="text-[#344054] text-sm font-medium">
                            Email <span className="text-red-500 required-dot">*</span>
                          </label>
                        </div>
                        <InputText
                          onChange={e => setEmail(e.target.value)}
                          value={email}
                          type="email"
                          id="required-email"
                          className="w-full placeholder:text-[#667085] placeholder:text-sm"
                          placeholder="youremail@gusd.net"
                        />
                      </div>

                      <div className="relative mb-2 xl:mb-[0.781vw] password-custom">
                        <div className="py-2">
                          <label htmlFor="required-password" className="text-[#344054] text-sm font-medium">
                            Password <span className="text-red-500 required-dot">*</span>
                          </label>
                        </div>
                        <Password
                          feedback={false}
                          onChange={e => setPassword(e.target.value)}
                          value={password}
                          type="password"
                          id="required-password"
                          toggleMask
                          className="w-full placeholder:text-[#667085] placeholder:text-sm"
                        />
                      </div>
                      {/* <Link to='/forgotpassword' className="font-medium flex justify-end text-xs py-[6px] rounded-[8px] text-[#113699]"
                      >Forgot Password</Link> */}

                      <div className="flex w-full my-2 xl:my-[2.083vw]">
                        <button type="submit" className="w-full text-center custmBtn blue radius8">
                          {showPleaseWaitButton ? "Please wait..." : "Login"}
                        </button>
                      </div>
                    </form>

                  </>

                )}



            </div>
          </div>

          <div
            className="py-[20px] px-[40px]  xl:py-[9.375vw] xl:px-[6.354vw]"
            data-aos="fade-left"
            data-aos-duration="800"
          >
            <Image
              className="relative xl:h-[31.250vw] xl:w-[36.458vw]"
              src={loginPage}
              width={"700"}
              height={"600"}
              alt="GUSD forms"
            />
          </div>
        </div>
      </div>
    </>
  );
}
